// Navbar.tsx
import React from "react";
import {
  Box,
  VStack,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import ScrollComponent from "./base/ScrollComponent";
import IconWithLink from "./base/IconWithLink";
import Logo from "./base/Logo";
import { border } from "../constants/constants";

const tabs = [
  { to: "about", label: "About" },
  { to: "experience", label: "Experience" },
  { to: "skills", label: "Skills" },
  { to: "projects", label: "Projects" },
  { to: "contact", label: "Contact" },
];

export const SIDEBAR_WIDTH = "88px";

const Navbar: React.FC = () => {
  return (
    <>
      {/* Desktop left sidebar */}
      <Box
        as="nav"
        aria-label="Primary"
        position="fixed"
        left={0}
        top={0}
        height="100vh"
        width={SIDEBAR_WIDTH}
        display={{ base: "none", md: "flex" }}
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        py={8}
        zIndex={100}
        borderRight="1px solid"
        borderColor={border}
        bg="brand.bg"
      >
        <Box
          as="a"
          href="#home"
          aria-label="Home"
          color="brand.text"
          _hover={{ color: "brand.accent" }}
          transition="color 0.2s ease"
        >
          <Logo size="32px" />
        </Box>

        <VStack spacing={10}>
          {tabs.map((tab) => (
            <ScrollComponent key={tab.to} to={tab.to} label={tab.label} />
          ))}
        </VStack>

        <VStack spacing={4}>
          <IconWithLink iconType="linkedIn" />
          <IconWithLink iconType="github" />
        </VStack>
      </Box>

      {/* Mobile top bar */}
      <Box
        as="nav"
        aria-label="Primary"
        display={{ base: "flex", md: "none" }}
        position="sticky"
        top={0}
        zIndex={100}
        p={4}
        justifyContent="left"
        bg="brand.bg"
      >
        <Menu>
          <MenuButton
            as={IconButton}
            icon={<HamburgerIcon />}
            variant="outline"
            borderColor={border}
            color="brand.text"
            _hover={{ bg: "brand.surface" }}
            aria-label="Open Menu"
          />
          <MenuList
            minWidth="auto"
            left="50%"
            transform="translateX(-50%)"
            bg="brand.surface"
            borderColor={border}
          >
            <MenuItem
              as="a"
              href="#home"
              textAlign="center"
              bg="brand.surface"
              color="brand.text"
              _hover={{ color: "brand.accent", bg: "brand.surfaceAlt" }}
            >
              Home
            </MenuItem>
            {tabs.map((tab) => (
              <MenuItem
                key={tab.to}
                as="a"
                href={`#${tab.to}`}
                textAlign="center"
                bg="brand.surface"
                color="brand.text"
                _hover={{ color: "brand.accent", bg: "brand.surfaceAlt" }}
              >
                {tab.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    </>
  );
};

export default Navbar;
